import { gql } from 'graphql-request'

export const GET_STATUS_SHELF = gql`
  query IsBookOnShelf($bookId: Int!) {
    isBookOnShelf(bookId: $bookId)
  }
`
